import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute, RoleRedirect, OpenActivity } from "./components/ProtectedRoute";
import PublicLayout from "./components/public/PublicLayout";
import SharedReportPage from "./pages/public/SharedReport";
import DashboardLayout from "./components/dash/DashboardLayout";
import Home from "./pages/public/Home";
import { Opportunities, FarmMap, HowItWorksPage, Offtake, NewsPage, FarmerGroupsPublic, NotFound, LandDetail, MonitoringPage, OrgProfile } from "./pages/public/InfoPages";
import { LoginPage, ForgotPasswordPage, ResetPasswordPage, RegisterOwnerPage } from "./pages/auth/AuthPages";
import LegalDocsPage from "./pages/legal/LegalDocs";
import { PrintPhotoReport } from "./components/coffee/PhotoHistory";
import PhotoArchive from "./pages/archive/PhotoArchive";
import { AdminDashboard, AdminApprovals, AdminAuditLog, AdminSettings } from "./pages/admin/AdminPages";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminNotifications from "./pages/admin/AdminNotifications";
import AdminManagerRequests from "./pages/admin/AdminManagerRequests";
import ManagerRequestsInbox from "./pages/manager/ManagerRequestsInbox";
import AdminWatchlist from "./pages/admin/AdminWatchlist";
import AdminSecurity from "./pages/admin/AdminSecurity";
import AdminImbalanRecap from "./pages/admin/AdminImbalanRecap";
import AdminBookkeeping from "./pages/admin/AdminBookkeeping";
import AdminSimParams from "./pages/admin/AdminSimParams";
import AsumsiBagiHasil from "./pages/public/AsumsiBagiHasil";
import { AdminFarmerGroups, AdminInvestors, AdminLand, AdminProjects, AdminUsers, AdminMedia, AdminOwners } from "./pages/admin/AdminCrud";
import { AdminInterests } from "./pages/admin/AdminCoffee";
import { MemberDashboard, MyLand, MyProjects, MediaGallery, Documents, Profile } from "./pages/member/MemberPages";
import ActivityForm from "./pages/activity/ActivityForm";
import ActivityDetail from "./pages/activity/ActivityDetail";
import { ActivitiesPage, HarvestPage, ExpensesPage, IssuesPage } from "./pages/activity/ActivityPages";
import ProjectWorkspace, { InvestorProjects } from "./pages/projects/ProjectWorkspace";
import { Navigate } from "react-router-dom";
import ProfitList from "./pages/profit/ProfitList";
import LandList from "./pages/lands/LandList";
import LandForm from "./pages/lands/LandForm";
import LandDetailPage from "./pages/lands/LandDetail";
import { InvestorLandList, InvestorLandDetail } from "./pages/lands/InvestorLands";
import { RencanaKebunList, RencanaKebunDetail, MinatSaya } from "./pages/investor/RencanaKebun";
import { InvestorApplicationPage, InvestorRevisePage, InvestorActivationPage } from "./pages/public/InvestorApplication";
import AdminInvestorApplications from "./pages/admin/AdminInvestorApplications";
import InvestorStatusPage from "./pages/public/InvestorStatus";
import { PrivacyPage, TermsPage } from "./pages/public/Legal";
import InvestorManagers from "./pages/investor/InvestorManagers";
import ProfitDetail from "./pages/profit/ProfitDetail";
import { LandApplicationPage, TrackApplicationPage } from "./pages/public/LandApplication";
import { AdminLandApplications, AdminLandApplicationDetail } from "./pages/admin/AdminLandApplications";
import { ManagerRegistrationPage, TrackManagerPage } from "./pages/public/ManagerRegistration";
import { AdminManagers, AdminManagerDetail } from "./pages/admin/AdminManagers";

const guard = (role) => (
  <ProtectedRoute roles={[role]}><DashboardLayout /></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="peluang-investasi" element={<Opportunities />} />
              <Route path="peluang-investasi/:code" element={<LandDetail />} />
              <Route path="monitoring-kebun" element={<MonitoringPage />} />
              <Route path="peta-lahan" element={<FarmMap />} />
              <Route path="ajukan-lahan" element={<LandApplicationPage />} />
              <Route path="ingin-menjadi-pemodal" element={<InvestorApplicationPage />} />
              <Route path="ingin-menjadi-pemodal/perbaiki" element={<InvestorRevisePage />} />
              <Route path="ingin-menjadi-pemodal/cek-status" element={<InvestorStatusPage />} />
              <Route path="aktivasi-pemodal" element={<InvestorActivationPage />} />
              <Route path="kebijakan-privasi" element={<PrivacyPage />} />
              <Route path="syarat-penggunaan" element={<TermsPage />} />
              <Route path="pengajuan-lahan/:id" element={<TrackApplicationPage />} />
              <Route path="daftar-pengelola" element={<ManagerRegistrationPage />} />
              <Route path="pendaftaran-pengelola/:id" element={<TrackManagerPage />} />
              <Route path="kelompok-tani" element={<FarmerGroupsPublic />} />
              <Route path="kelompok-tani/:id" element={<OrgProfile />} />
              <Route path="cara-kerja" element={<HowItWorksPage />} />
              <Route path="asumsi-bagi-hasil" element={<AsumsiBagiHasil />} />
              <Route path="offtake-pt-sji" element={<Offtake />} />
              <Route path="berita" element={<NewsPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/lupa-password" element={<ForgotPasswordPage />} />
            <Route path="/daftar-pemilik-lahan" element={<RegisterOwnerPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<RoleRedirect />} />
            <Route path="/buka/kegiatan/:id" element={<OpenActivity />} />
            <Route path="/rapor/:token" element={<SharedReportPage />} />

            <Route path="/dashboard/admin" element={guard("SUPER_ADMIN")}>
              <Route index element={<AdminDashboard />} />
              <Route path="kelompok-tani" element={<AdminFarmerGroups />} />
              <Route path="investor" element={<AdminInvestors />} />
              <Route path="lahan" element={<AdminLand />} />
              <Route path="pemantauan-lahan" element={<LandList />} />
              <Route path="pemantauan-lahan/:id" element={<LandDetailPage />} />
              <Route path="proyek" element={<AdminProjects />} />
              <Route path="minat-investasi" element={<AdminInterests />} />
              <Route path="pengajuan-pemodal" element={<AdminInvestorApplications />} />
              <Route path="pemilik-lahan" element={<AdminOwners />} />
              <Route path="legalitas" element={<LegalDocsPage />} />
              <Route path="proyek/:id" element={<ProjectWorkspace />} />
              <Route path="kegiatan/:id" element={<ActivityDetail />} />
              <Route path="persetujuan" element={<AdminApprovals />} />
              <Route path="media" element={<AdminMedia />} />
              <Route path="arsip-foto" element={<PhotoArchive />} />
              <Route path="proyek/:id/cetak-foto" element={<PrintPhotoReport />} />
              <Route path="pengguna" element={<AdminUsers />} />
              <Route path="audit-log" element={<AdminAuditLog />} />
              <Route path="pengajuan" element={<AdminSubmissions />} />
              <Route path="pengajuan-lahan" element={<AdminLandApplications />} />
              <Route path="pengajuan-lahan/:id" element={<AdminLandApplicationDetail />} />
              <Route path="pengelola-perorangan" element={<AdminManagers />} />
              <Route path="pengajuan-pengelola" element={<AdminManagerRequests />} />
              <Route path="pengelola-perorangan/:id" element={<AdminManagerDetail />} />
              <Route path="bagi-hasil" element={<ProfitList />} />
              <Route path="bagi-hasil/:id" element={<ProfitDetail />} />
              <Route path="rekap-imbalan" element={<AdminImbalanRecap />} />
              <Route path="arsip-pembukuan" element={<AdminBookkeeping />} />
              <Route path="asumsi-bagi-hasil" element={<AdminSimParams />} />
              <Route path="notifikasi" element={<AdminNotifications />} />
              <Route path="daftar-hitam" element={<AdminWatchlist />} />
              <Route path="keamanan" element={<AdminSecurity />} />
              <Route path="pengaturan" element={<AdminSettings />} />
              <Route path="profil" element={<Profile />} />
            </Route>

            <Route path="/dashboard/kelompok-tani" element={guard("FARMER_GROUP")}>
              <Route index element={<MemberDashboard />} />
              <Route path="investor-proyek" element={<InvestorProjects />} />
              <Route path="permintaan-pengelolaan" element={<ManagerRequestsInbox />} />
              <Route path="lahan" element={<LandList />} />
              <Route path="lahan/baru" element={<LandForm />} />
              <Route path="lahan/:id" element={<LandDetailPage />} />
              <Route path="lahan/:id/ubah" element={<LandForm />} />
              <Route path="proyek" element={<MyProjects />} />
              <Route path="proyek/:id" element={<ProjectWorkspace />} />
              <Route path="proyek/:id/cetak-foto" element={<PrintPhotoReport />} />
              <Route path="arsip-foto" element={<PhotoArchive />} />
              <Route path="legalitas" element={<LegalDocsPage />} />
              <Route path="kegiatan" element={<ActivitiesPage />} />
              <Route path="kegiatan/baru" element={<ActivityForm />} />
              <Route path="kegiatan/:id" element={<ActivityDetail />} />
              <Route path="kegiatan/:id/ubah" element={<ActivityForm />} />
              <Route path="update-lapangan" element={<Navigate to="../kegiatan" replace />} />
              <Route path="biaya" element={<ExpensesPage />} />
              <Route path="panen" element={<HarvestPage />} />
              <Route path="bagi-hasil" element={<ProfitList />} />
              <Route path="bagi-hasil/:id" element={<ProfitDetail />} />
              <Route path="media" element={<MediaGallery />} />
              <Route path="masalah" element={<IssuesPage />} />
              <Route path="dokumen" element={<Documents />} />
              <Route path="profil" element={<Profile />} />
            </Route>

            <Route path="/dashboard/pengelola" element={guard("INDIVIDUAL_MANAGER")}>
              <Route index element={<MemberDashboard />} />
              <Route path="permintaan-pengelolaan" element={<ManagerRequestsInbox />} />
              <Route path="proyek" element={<MyProjects />} />
              <Route path="proyek/:id" element={<ProjectWorkspace />} />
              <Route path="proyek/:id/cetak-foto" element={<PrintPhotoReport />} />
              <Route path="arsip-foto" element={<PhotoArchive />} />
              <Route path="kegiatan" element={<ActivitiesPage />} />
              <Route path="kegiatan/baru" element={<ActivityForm />} />
              <Route path="kegiatan/:id" element={<ActivityDetail />} />
              <Route path="kegiatan/:id/ubah" element={<ActivityForm />} />
              <Route path="biaya" element={<ExpensesPage />} />
              <Route path="panen" element={<HarvestPage />} />
              <Route path="bagi-hasil" element={<ProfitList />} />
              <Route path="bagi-hasil/:id" element={<ProfitDetail />} />
              <Route path="media" element={<MediaGallery />} />
              <Route path="masalah" element={<IssuesPage />} />
              <Route path="dokumen" element={<Documents />} />
              <Route path="profil" element={<Profile />} />
            </Route>

            <Route path="/dashboard/pemilik-lahan" element={guard("PRIVATE_LAND_OWNER")}>
              <Route index element={<MemberDashboard />} />
              <Route path="proyek" element={<MyProjects />} />
              <Route path="proyek/:id" element={<ProjectWorkspace />} />
              <Route path="proyek/:id/cetak-foto" element={<PrintPhotoReport />} />
              <Route path="arsip-foto" element={<PhotoArchive />} />
              <Route path="kegiatan" element={<ActivitiesPage />} />
              <Route path="kegiatan/:id" element={<ActivityDetail />} />
              <Route path="biaya" element={<ExpensesPage />} />
              <Route path="panen" element={<HarvestPage />} />
              <Route path="media" element={<MediaGallery />} />
              <Route path="dokumen" element={<Documents />} />
              <Route path="profil" element={<Profile />} />
            </Route>
            <Route path="/dashboard/investor" element={guard("INVESTOR")}>
              <Route index element={<MemberDashboard />} />
              <Route path="proyek" element={<MyProjects />} />
              <Route path="proyek/:id" element={<ProjectWorkspace />} />
              <Route path="proyek/:id/cetak-foto" element={<PrintPhotoReport />} />
              <Route path="arsip-foto" element={<PhotoArchive />} />
              <Route path="kegiatan" element={<ActivitiesPage />} />
              <Route path="kegiatan/:id" element={<ActivityDetail />} />
              <Route path="update-lapangan" element={<Navigate to="../kegiatan" replace />} />
              <Route path="biaya" element={<ExpensesPage />} />
              <Route path="bagi-hasil" element={<ProfitList />} />
              <Route path="bagi-hasil/:id" element={<ProfitDetail />} />
              <Route path="rencana-kebun" element={<RencanaKebunList />} />
              <Route path="rencana-kebun/:id" element={<RencanaKebunDetail />} />
              <Route path="minat-saya" element={<MinatSaya />} />
              <Route path="lahan-tersedia" element={<InvestorLandList />} />
              <Route path="lahan-tersedia/:id" element={<InvestorLandDetail />} />
              <Route path="pengelola" element={<InvestorManagers />} />
              <Route path="media" element={<MediaGallery />} />
              <Route path="dokumen" element={<Documents />} />
              <Route path="profil" element={<Profile />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
